var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('fullscreen-image'),_c('the-header'),_c('main',[_c('the-map'),_c('div',{staticClass:"content"},[_c('router-view')],1),_c('the-timeline'),_c('mobile-navigator')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }